"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auroraPalette = void 0;
var themeCreator_1 = __importDefault(require("./themeCreator"));
exports.auroraPalette = {
    component: {
        answerSelectedColor: 'rgb(0, 140, 255)',
        answerUnselectedColor: 'rgb(148, 148, 148)',
        continueButtonColor: 'rgb(6, 171, 72)',
        continueButtonHoverColor: 'rgb(3, 144, 60)',
        backButtonColor: 'rgb(237, 237, 237)',
        backButtonHoverColor: 'rgb(223, 223, 223)',
        progressBarFilledColor: 'rgb(0, 140, 255)',
        progressBarUnfilledColor: 'rgb(247, 247, 247)',
        scrollIndicatorColor: 'rgb(79, 79, 79)',
    },
    background: {
        answerBackgroundColor: 'rgb(255, 255, 255)',
        secondaryBackgroundColor: 'rgb(247, 247, 247)',
        widgetBackgroundColor: 'rgb(255,255,255)',
    },
    text: {
        primaryTextColor: 'rgb(0, 0, 0)',
        continueButtonTextColor: 'rgb(255, 255, 255)',
        secondaryTextColor: 'rgb(79, 79, 79)',
    },
    status: {
        disabled: 'rgb(134, 134, 134)',
        error: 'rgb(249, 98, 78)',
    },
};
var auroraTheme = (0, themeCreator_1.default)(exports.auroraPalette);
exports.default = auroraTheme;
//# sourceMappingURL=auroraTheme.js.map